import React from 'react';
import classNames from 'classnames';
import css from './fallback-banner.module.scss';

type FallbackBannerProps = {
    className?: string;
    children?: React.ReactNode;
    icon?: React.ReactNode;
    showArrow?: boolean;
};

export const FallbackBanner = ({
    className,
    children,
    icon,
    showArrow
}: FallbackBannerProps) => {
    return (
        <div
            className={classNames(
                { [css.withArrowTop]: showArrow },
                'p-2 p-md-4 bg-light text-center',
                className
            )}>
            <div className="m-2 m-md-3">{icon}</div>
            {children}
        </div>
    );
};
